import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { Typography } from "@mui/material";

const linkMap = {
  Athletes: "/profiles",
  About: "/about",
  // News: "/news",
  Contact: "/contact",
  "2013 Results": "/results-2013",
  "2014 Results": "/results-2014",
  "2015 Results": "/results-2015",
  "2017 Results": "/results-2017",
  "2022 Mr America": "/results-2022",
  "2023 Mr America": "/results-2023",
  "2024 Mr America": "/2024-MrAmerica",
  "2024 USA Fit Fest": "/2024-FitFest",
  "2025 Results": "/results-2025",
  Stats: "/stats",
};

const useStyles = makeStyles({
  text: { color: "#769525", fontFamily: "Impact" },
  link: { textDecoration: "none", color: "#769525", fontFamily: "Impact" },
});

export default function NavMenu({ title, menuItems, icon }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="Nav-button"
        aria-controls={open ? "Nav-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{ color: "#769525", fontFamily: "Impact", fontSize: "1.75rem" }}
      >
        {title}
        {icon}
      </Button>
      <Menu
        id="Nav-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "Nav-button",
        }}
      >
        {menuItems.map((item, idx) => (
          <Link key={idx} to={linkMap[item]} className={classes.link}>
            <MenuItem onClick={handleClose}>
              <Typography className={classes.text}>{item}</Typography>
            </MenuItem>
          </Link>
        ))}
      </Menu>
    </div>
  );
}
